export declare namespace AppActivityDataStepSidebarTokenSections {
	interface Item {
		padding: string;
		minHeight: string;
		background: string;
		color: string;
		registrationNumberColor: string;
		fontSize: string;
		lineHeight: string;
		fontWeight: string;
		fontFamily: string;
		labelFlex: string;
	}

	interface ItemSelected {
		background: string;
		color: string;
		registrationNumberColor: string;
		accentBorderColor: string;
	}

	interface ItemChevron {
		size: string;
		iconFontSize: string;
		borderWidth: string;
	}

	interface ItemTrailing {
		gap: string;
	}

	interface ConfirmedIndicator {
		size: string;
		background: string;
		padding: string;
		borderRadius: string;
		iconColor: string;
		iconSize: string;
	}
}

export type AppActivityDataStepSidebarTokens = {
	sidebarWidth: string;
	gap: string;
	item: AppActivityDataStepSidebarTokenSections.Item;
	itemSelected: AppActivityDataStepSidebarTokenSections.ItemSelected;
	itemChevron: AppActivityDataStepSidebarTokenSections.ItemChevron;
	itemTrailing: AppActivityDataStepSidebarTokenSections.ItemTrailing;
	confirmedIndicator: AppActivityDataStepSidebarTokenSections.ConfirmedIndicator;
};

/** Pagal Figma 11340-27422/27423 (dar nieko): surface.300 fonas, baltas tekstas, surface.200 reg.nr. */
export const item: AppActivityDataStepSidebarTokenSections.Item = {
	padding: '12px',
	/** Figma 11340-27409: 12px + 32px eilutė + 12px = 56px */
	minHeight: '56px',
	background: '{surface.300}',
	color: '{primary.contrast.color}',
	registrationNumberColor: '{surface.200}',
	fontSize: '20px',
	lineHeight: '32px',
	fontWeight: '500',
	fontFamily: 'inherit',
	labelFlex: '1 0 0',
};

/** Pasirinkta veikla — Figma 11340-27409: surface.700 + akcentas (kaip klausimyno active kortelė). */
export const itemSelected: AppActivityDataStepSidebarTokenSections.ItemSelected = {
	background: '{surface.700}',
	color: '{primary.contrast.color}',
	registrationNumberColor: '{surface.400}',
	accentBorderColor: '{form.field.focus.border.color}',
};

/** Kaip klausimynas (`questionnaire-step-sidebar-chevron`): 2rem apskritimas, `pi-angle-right` 1rem. */
export const itemChevron: AppActivityDataStepSidebarTokenSections.ItemChevron = {
	size: '2rem',
	iconFontSize: '1rem',
	borderWidth: '2px',
};

export const itemTrailing: AppActivityDataStepSidebarTokenSections.ItemTrailing = {
	gap: '12px',
};

/** Tas pats išorinis dydis kaip chevron (2rem). */
export const confirmedIndicator: AppActivityDataStepSidebarTokenSections.ConfirmedIndicator = {
	size: '2rem',
	background: '{green.500}',
	padding: '0',
	borderRadius: '9999px',
	iconColor: '{surface.0}',
	iconSize: '1rem',
};

/**
 * Veiklų duomenų žingsnio kairės pusės (veiklų sąrašo) stiliai – pagal Figma (node 11340-26836, 11340-27755, 11340-27409, 11340-27423).
 * Naudojamas .app-activity-data-step-sidebar, .item, .item.confirmed, .item.selected, .item-registration,
 * .item-confirmed-indicator (žalias apskritimas su check), .item-chevron / .item-chevron-icon (kaip klausimynas).
 * Nepasirinkta = surface.300; pasirinkta (.selected) = surface.700 + kairioji akcento linija.
 * Užpildyta (.confirmed) = tik žalias check, fonas nekeičiamas.
 */
export default {
	sidebarWidth: '409px',
	gap: '12px',
	item,
	itemSelected,
	itemChevron,
	itemTrailing,
	confirmedIndicator,
} satisfies AppActivityDataStepSidebarTokens;
